import React, { useState } from "react";
import "./App.css";
import { Switch, Route, BrowserRouter as Router } from "react-router-dom";
import ConfigPage from "./ConfigPage";
import SelectionPage from "./SelectionPage";
import { TagManager } from "../model/TagManager";
import WelcomePage from "./WelcomePage";
import ConfigActionsPage from "./ConfigActionsPage";
import AboutPage from "./AboutPage";

const App: React.FC = () => {
	const tagManager = new TagManager();

	const [welcomePage, setWelcomePage] = useState(tagManager.firstOpening);

	const onDisableWelcomePage = () => {
		setWelcomePage(false);
	};

	return (
		<Router>
			<div className="App w3-auto">
				{welcomePage ? (
					<Switch>
						<Route path="/about">
							<AboutPage />
						</Route>
						<Route path="*">
							<WelcomePage
								tagManager={tagManager}
								onDisableWelcomePage={onDisableWelcomePage}
							/>
						</Route>
					</Switch>
				) : (
					<Switch>
						<Route path="/config">
							<ConfigPage tagManager={tagManager} />
						</Route>
						<Route path="/configactions">
							<ConfigActionsPage tagManager={tagManager} />
						</Route>
						<Route path="/about">
							<AboutPage />
						</Route>
						<Route path="/">
							<SelectionPage tagManager={tagManager} />
						</Route>
					</Switch>
				)}

				<p className="App-copyright w3-padding">
					Copyright &copy; 2020 Andreas Weizel
				</p>
			</div>
		</Router>
	);
};

export default App;
